import { _, App, HostApp } from '@zto/zpage'

import { UI_GLOBAL_EVENTS } from '../consts'

/** 打开下载列表对话框 */
export function openDownloadsDialog() {
  if (!HostApp.app) throw new Error('主应用未初始化')

  HostApp.app?.emitter.emit(UI_GLOBAL_EVENTS.OPEN_DOWNLOADS)
}

/** 执行一步导出 */
export async function doAsyncExport(app: App, options?: any) {
  const exportConfig = app.useWidgetsConfig('crud.export', {})
  const api = options?.api || exportConfig.api

  /** 导出上下文数据 */
  const exportContext = options?.context || app.useContext(options.contextData)

  if (options?.beforeExport) {
    const flag = await Promise.resolve().then(() => options?.beforeExport(exportContext, options))
    if (flag === false) return
  }

  let exportApiParams: any = {}

  const searchParamProp = options.searchParamProp || exportConfig.searchParamProp || 'search'

  const searchTypeProp = options.searchTypeProp || exportConfig.searchTypeProp || 'exportType' // 导出类型
  const searchType = options.exportType || options.type

  if (_.isFunction(options.apiParams)) {
    exportApiParams = options.apiParams(exportContext)
  } else {
    let searchParams: any = {}
    if (_.isFunction(options.searchParams)) {
      searchParams = options.searchParams(exportContext)
    } else {
      searchParams = { ...options.searchParams }
    }

    exportApiParams = { [searchTypeProp]: searchType, [searchParamProp]: searchParams, ...options.apiParams }
  }

  await app.request({ action: { api, type: 'export' }, params: exportApiParams })

  if (options?.openDownloads !== false) {
    openDownloadsDialog()
  }

  setTimeout(() => {
    app.ui.showMessage({
      type: 'success',
      message: options?.successMessage || '导出成功！'
    })
  }, 100)
}

/**
 * 获取表单上下文
 * @param payload
 * @param context
 * @returns
 */
export function getActionPayload(payload: any, context: any) {
  if (_.isFunction(payload)) {
    return payload(context)
  } else if (Array.isArray(payload)) {
    const result = payload.reduce((acc: any, key: string) => {
      if (key) acc[key] = _.get(context, key)
      return acc
    }, {})
    return result
  } else {
    return payload
  }
}

export interface CmptPermOptions {
  perm?: boolean | string // 权限开关/权限设置标记
  perms?: string | string[] // 权限数组
  api?: any
  [key: string]: any
}

/**
 * 获取组件权限数据
 * @param options
 * @returns
 */
export function getCmptPermData(options: CmptPermOptions) {
  // 没有权限配置，则直接返回
  if (!options) return null

  // 关闭权限配置，则直接返回
  if (options.perm == false) return null

  if (options.perms) return Array.isArray(options.perms) ? options.perms : [options.perms]

  if (!options.perm) return null

  if (_.isString(options.perm)) return [options.perm]

  if (options.perm === true && options.api) {
    if (_.isString(options.api)) return [options.api]
    if (_.isString(options.api.api)) return [options.api.api]
  }

  return null
}
